import React from 'react'
import { Field } from '@ztechapps/webui.form'
import { TextInput } from '@ztechapps/webui.input'
import { useContext } from './Context'
import { useFormikContext } from 'formik'
import { ShowIf } from '@ztechapps/webui.util'

export const FormFields = () => {
  const { withCurrentPasswordForm } = useContext()
  const { status } = useFormikContext()

  return (
    <ShowIf condition={status !== 'success'}>
      <ShowIf condition={withCurrentPasswordForm}>
        <div className="mb-2">
          <Field
            name="currentPassword"
            type="password"
            label="Current Password"
            required
            minLength={6}
            component={TextInput}
            help="The current password you used to login."
          />
        </div>
      </ShowIf>

      <div className="mb-2">
        <Field
          name="password"
          type="password"
          label="New Password"
          required
          minLength={6}
          component={TextInput}
          help="We suggest to use the password generator of the browser."
        />
      </div>

      <div className="mb-2">
        <Field name="confirmPassword" type="password" label="Confirm Password" required minLength={6} component={TextInput} />
      </div>
    </ShowIf>
  )
}
